/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Su_Password_PhInputs */

const en_funnel_su_password_ph = /** @type {(inputs: Funnel_Su_Password_PhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password (at least 8 characters)`)
};

const es_funnel_su_password_ph = /** @type {(inputs: Funnel_Su_Password_PhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contraseña (mínimo 8 caracteres)`)
};

/**
* | output |
* | --- |
* | "Password (at least 8 characters)" |
*
* @param {Funnel_Su_Password_PhInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_su_password_ph = /** @type {((inputs?: Funnel_Su_Password_PhInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Su_Password_PhInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_su_password_ph(inputs)
	return en_funnel_su_password_ph(inputs)
});